import { ClickableIcon } from "../../../../../../../components/Icon/ClickableIcon.tsx";
import type { IconName } from "../../../../../../../components/Icon/Icon.tsx";
import { TEXT_ALIGNMENTS } from "../../../Designer/constants.ts";
import type { TextAlignment } from "../../../Designer/types.ts";

const ALIGNMENT_BUTTON_DISPLAY: Record<
  TextAlignment,
  {
    iconName: IconName;
    tooltip: string;
  }
> = {
  left: {
    tooltip: "Align text to the left",
    iconName: "AlignLeft",
  },
  center: {
    tooltip: "Center text",
    iconName: "AlignCenter",
  },
  right: {
    tooltip: "Align text to the right",
    iconName: "AlignRight",
  },
  justify: {
    tooltip: "Justify text",
    iconName: "AlignJustify",
  },
};

export const TextAligmentSelection = ({
  alignment,
  setAlignment,
}: {
  alignment: TextAlignment;
  setAlignment: (alignment: TextAlignment) => void;
}) => (
  <div className="flex-row items-center gap-100">
    {TEXT_ALIGNMENTS.map((alignmentChoice) => (
      <AlignmentButton
        key={alignmentChoice}
        alignment={alignmentChoice}
        setAlignment={setAlignment}
        disabled={alignment === alignmentChoice}
      />
    ))}
  </div>
);

const AlignmentButton = ({
  alignment,
  setAlignment,
  disabled,
}: {
  alignment: TextAlignment;
  setAlignment: (alignment: TextAlignment) => void;
  disabled?: boolean;
}) => {
  const alignText = () => {
    setAlignment(alignment);
  };
  return (
    <ClickableIcon
      name={ALIGNMENT_BUTTON_DISPLAY[alignment].iconName}
      size="sm"
      variant="secondary"
      onClick={alignText}
      disabled={disabled}
      tooltip={{
        content: ALIGNMENT_BUTTON_DISPLAY[alignment].tooltip,
      }}
    />
  );
};
